<template>
    <HeaderBar v-if="!appData.isMobile">
        <template #default>
            <li><router-link :to="Links.Url(Links.User.Message)" class="dropdown-item"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>Mesajlarım</router-link></li>
        </template>
        <template #rule>{{list.lessonArea.getName()}} Öğrenci</template>
    </HeaderBar>
    <HeaderBarMobile v-else>
        <slot></slot>
    </HeaderBarMobile>
</template>
<script>
    import { reactive, toRefs, computed, nextTick } from "vue";
    import { useStore } from "vuex";

    import HeaderBar from "@/layouts/_partials/HeaderBar.vue";
    import HeaderBarMobile from "@/layouts/_partials/HeaderBar.mobile.vue";

    import { appData, C, J } from "@/helpers/global";
    import { Web, Wait } from "@/helpers/web";

    import { StoreUser, StoreLessonArea } from "@/store/constants";

    export default {
        components: {
            HeaderBar,
            HeaderBarMobile,
        },
        mounted() {
            const _this = this;
            try {
                _this.get(false);
            } catch (ex) { console.warn(ex); }
        },
        setup(props) {
            const store = useStore();
            const e = reactive({
                get(reset) {
                    e.user.loadDetail(() => {
                        e.list.lessonArea.load(() => {});
                    }, reset);
                },
                user: {
                    loadDetail(callback, reset) {
                        if (C.Int(e.user.detail?.userType) <= 0) { reset = true; }
                        Web.Area((wait) => {
                            store.dispatch(StoreUser.loadDetail, { wait, reset, callback });
                        }, appData.fn.main());
                    },
                    detail: computed(() => {
                        return store.getters[StoreUser.getDetail];
                    }),
                    lessonAreaId: computed(() => {
                        if (e.user.detail) {
                            return C.Int(e.user.detail.lessonAreaId);
                        }
                        return 0;
                    }),
                },
                list: {
                    lessonArea: {
                        load(callback) {
                            nextTick(() => {
                                Web.Area((wait) => {
                                    store.dispatch(StoreLessonArea.loadList, { wait, callback });
                                }, appData.fn.main());
                            });
                        },
                        get: computed(() => {
                            return store.getters[StoreLessonArea.getList];
                        }),
                        getName() {
                            const name = J.FindKey(e.list.lessonArea.get, e.user.lessonAreaId);
                            return name ? name + " " : "";
                        }
                    },
                }
            });
            return { ...toRefs(e) };
        },
    };
</script>